import { useMemo } from 'react';
import { useI18n } from '~/app/i18n/i18n';
import { ConflictData } from '~/app/pages/configurator/components/conflict-dialog/use-conflict-handler';
import { ConfiguredCarFeatureFragment } from '~/graphql/__generated__/graphql';

// Return an array of the names of the conflict solution groups for tracking

const useConflictSolutionGroups = (data: ConflictData) => {
	const { i18n } = useI18n();

	const solutionGroups = useMemo(() => {
		const allItemsSameGroup = (items: ConfiguredCarFeatureFragment[]) =>
			items.every((item) => item.family.name === items[0].family.name);

		return data.solutionGroups
			.filter((group) => group.solutions.length > 1)
			.map((group) => group.solutions.map((solution) => solution.feature))
			.map((features) => {
				return {
					name: allItemsSameGroup(features)
						? features[0].family.name
						: i18n(`ngc.types.ConfiguredCarFeature.${features[0].featureType}`),
				};
			});
	}, [data.solutionGroups, i18n]);

	return solutionGroups;
};

export default useConflictSolutionGroups;
